export default {
  ResourceList: () => import('@/views/system/resource/ResourceList')
}